import CalendarContainer from "@legacy/calendar/CalendarContainer"

import { faIcon } from "@utils/faIcon"

import { NavTopBar } from "@organisms"

import { AppFrame } from "@templates"

export default function Calendar() {
    return (
        <AppFrame.Root>
            <NavTopBar.Root>
                <NavTopBar.Header>
                    <NavTopBar.NavTopBarHeaderStart>
                        <NavTopBar.PageTitle
                            label="Calendar"
                            icon={faIcon({ name: "objects-align-left", style: "solid" })}
                        />
                    </NavTopBar.NavTopBarHeaderStart>
                </NavTopBar.Header>
            </NavTopBar.Root>
            <AppFrame.PageContent>
                <CalendarContainer />
            </AppFrame.PageContent>
        </AppFrame.Root>
    )
}
